import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { STICKY_MENU_MEDIA_QUERIES } from '../forms/shared/MediaQueryUtils';

const DateTimeContainer = styled(Box)(({ theme }) => ({
  padding: 0,
  borderRadius: '.5rem',
  overflow: 'hidden',
  backgroundColor:
    theme.palette.mode === 'dark'
      ? theme.palette.primary.dark
      : theme.palette.primary.main,
  border:
    theme.palette.mode === 'dark'
      ? `3px solid ${theme.palette.primary.main}`
      : `3px solid ${theme.palette.primary.dark}`,
  textAlign: 'left',
  animation: 'fadeIn 0.5s ease-in-out',
  '@media (max-width: 600px)': {
    textAlign: 'center',
  },
}));

const DateDisplay = styled(Typography)(({ theme }) => ({
  fontSize: '2.2rem',
  fontWeight: 700,
  letterSpacing: '1px',
  color: theme.palette.grey[100],
  padding: '.1rem 0 .32rem 2.5rem',
  [STICKY_MENU_MEDIA_QUERIES.tablet]: {
    padding: '.1rem 0 .32rem 2.5rem',
  },
  [STICKY_MENU_MEDIA_QUERIES.desktop]: {
    padding: '.1rem 0 .32rem 2.5rem',
  },
  [STICKY_MENU_MEDIA_QUERIES.large]: {
    padding: '.1rem 0 .32rem 2.5rem',
  },
  [STICKY_MENU_MEDIA_QUERIES.mediumLarge]: {
    padding: '.1rem 0 .32rem 2.5rem',
  },
  [STICKY_MENU_MEDIA_QUERIES.xlarge]: {
    padding: '.2rem 0 .4rem 4.5rem',
  },
  [STICKY_MENU_MEDIA_QUERIES.xxlarge]: {
    padding: '.3rem 0 .6rem 2.5rem',
  },
  '@media (max-width: 600px)': {
    display: 'none',
  },
}));

const MobileDateDisplay = styled(Typography)(({ theme }) => ({
  fontSize: '2rem',
  fontWeight: 600,
  color: theme.palette.grey[100],
  padding: '.8rem 0 .8rem 0',
  display: 'none',
  '@media (max-width: 600px)': {
    display: 'block',
  },
}));

export default function DateTimeDisplay(): React.ReactElement {
  const [dateTime, setDateTime] = useState<Date>(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setDateTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const fullDate = dateTime.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const mobileDate = `${weekdays[dateTime.getDay()]}, ${months[dateTime.getMonth()]} ${dateTime.getDate()}, ${dateTime.getFullYear()}`;

  return (
    <DateTimeContainer
      sx={{
        mb: {
          xs: '.5rem',
          sm: '.51rem',
          md: '.5rem',
          lg: '.5rem',
          xl: '.5rem',
        },
      }}
    >
      <DateDisplay variant="body1">{fullDate}</DateDisplay>
      <MobileDateDisplay variant="body1">{mobileDate}</MobileDateDisplay>
    </DateTimeContainer>
  );
}
